import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetAccountEmailSequenceData as GetAccountEmailSequenceDataQuery,
    GetAccountEmailSequenceData_account_contacts_edges_node as ContactNode,
    GetAccountEmailSequenceData_account_queuedEmails as QueuedEmail,
    GetAccountEmailSequenceDataVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_EMAIL_SEQUENCE_DATA from '../queries/get-account-email-sequence-data.graphql';

export function useGetAccountEmailSequenceData(
    accountId: string,
    skip: boolean = false
): {
    contacts: ContactNode[] | undefined;
    queuedEmails: QueuedEmail[] | null | undefined;
    isFirstLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, error, networkStatus, refetch} = useQuery<
        GetAccountEmailSequenceDataQuery,
        GetAccountEmailSequenceDataVariables
    >(GET_ACCOUNT_EMAIL_SEQUENCE_DATA, {
        variables: {accountId},
        fetchPolicy: 'cache-and-network',
        skip,
    });

    const contacts = data?.account?.contacts?.edges?.map((edge) => edge.node);

    return {
        contacts,
        queuedEmails: data?.account?.queuedEmails,
        isFirstLoading: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
